import React, { useMemo, useState } from "react";
import "./HeroCompare.css";

const bellStates = [
  { mode: "Muted", subtitle: "No ambient audio", level: 0 },
  { mode: "Soft Chime", subtitle: "Small interaction cues", level: 1 },
  { mode: "Sound Ritual", subtitle: "Full ambient layer", level: 2 },
];

const HeroCompare = () => {
  const [bellIndex, setBellIndex] = useState(1);

  const bellState = useMemo(() => bellStates[bellIndex], [bellIndex]);

  const cycleBell = () => {
    setBellIndex((prev) => (prev + 1) % bellStates.length);
  };

  return (
    <main className="hero-compare-page">
      <header className="hero-compare-header">
        <p>Portfolio Hero Playground</p>
        <h1>Compare three directions (A/B/C)</h1>
        <span>Quick prototypes for feeling, not polish.</span>
      </header>

      <section className="hero-block hero-a">
        <div className="variant-label">Version A · Desktop mock</div>
        <div className="desktop-stage">
          <div className="desktop-float desktop-left">Selected Work</div>
          <div className="desktop-window">
            <div className="window-topbar">
              <span />
              <span />
              <span />
              <p>Quiet Desktop</p>
            </div>
            <div className="window-content">
              <div>
                <h2>I design digital experiences that feel calm and human.</h2>
                <p>
                  Product designer crafting thoughtful systems, interfaces, and
                  interactions for the long run.
                </p>
                <div className="button-row">
                  <button>Explore work</button>
                  <button className="ghost">About me</button>
                </div>
              </div>
              <div className="window-art" />
            </div>
          </div>
          <div className="desktop-float desktop-right">Field notes</div>
        </div>
      </section>

      <section className="hero-block hero-b">
        <div className="variant-label">Version B · Right-side UI + bell interaction</div>
        <div className="b-layout">
          <div className="b-copy">
            <h2>Design systems that make product decisions feel obvious.</h2>
            <p>
              Left side carries your narrative. Right side previews your UI
              artifacts and interactions.
            </p>
            <button className="primary">View selected work</button>
          </div>

          <div className="b-ui">
            <div className="ui-card large">
              <h3>Case study preview</h3>
              <div className="preview-tiles">
                <span />
                <span />
                <span />
                <span />
              </div>
            </div>
            <div className="ui-card small">
              <h3>Sound panel</h3>
              <button
                onClick={cycleBell}
                className={`bell-button level-${bellState.level}`}
                type="button"
              >
                Bell: {bellState.mode}
              </button>
              <p>{bellState.subtitle}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="hero-block hero-c">
        <div className="variant-label">Version C · Atomic direction</div>
        <div className="atomic-grid">
          <article className="atom atom-copy">
            <p className="kicker">Atomic Objects</p>
            <h2>Clear, modular, and composable.</h2>
            <p>
              Break hero content into reusable blocks that can remix across
              homepage, notes, and work archive.
            </p>
          </article>

          <article className="atom atom-stat">
            <p>01</p>
            <h3>Work</h3>
          </article>
          <article className="atom atom-stat">
            <p>02</p>
            <h3>Notes</h3>
          </article>
          <article className="atom atom-stat">
            <p>03</p>
            <h3>Experiments</h3>
          </article>
          <article className="atom atom-stat ritual">
            <p>Ritual</p>
            <h3>{bellState.mode}</h3>
          </article>
        </div>
      </section>
    </main>
  );
};

export default HeroCompare;
